import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthProvider';
import AxiosAuth from '../utility/AxiosAuth';
import ConfigApi from '../utility/ConfigApi';
import InitInfo from '../utility/InitInfo';
import { useTemplate } from '../context/TemplateProvider';

const Header = () => {
  const {userId} = InitInfo();

  const { headerText } = useTemplate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const {setUserSl } = useAuth();
  const {setMessage}=useTemplate()

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };
  const handleLogout=()=>{
    AxiosAuth.post(ConfigApi.LOGOUT, {userId})
    .then(({data}) => {
      
      if (data.error===0) {
        setUserSl('')
        localStorage.setItem('userId', '');
        setMessage({type: 'success', text: data.message})
      }else{
        
        setMessage({type: 'error', text: data.message})
      }
      
    })
    .catch(errr => {
      console.log(errr);
      
    });
    
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="fixed top-0 right-0 left-[250px] flex flex-row p-3 border-b-[1px] border-[#E1E3E1] z-10 bg-white">
      <div className="grow text-lg font-bold">{headerText}</div>
      <div className="flex flex-row items-center justify-end w-[150px] relative">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="me-2 w-[25px]">
          <path d="M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"/>
        </svg>
        
        <button
          id="dropdownUserAvatarButton"
          onClick={toggleDropdown}
          className="flex text-sm rounded-full md:me-0"
          type="button"
        >
          Sourav
        </button>

        {dropdownOpen && (
          <div
            id="dropdownAvatar"
            ref={dropdownRef}
            className="z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 dark:divide-gray-600 absolute top-10 right-0"
          >
            <div className="px-4 py-3 text-sm text-gray-900 dark:text-white">
              <div>Sourav Mallick</div>
            </div>
            <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownUserAvatarButton">
            
              <li>
                <a href="#" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Password Change</a>
              </li>
            
            </ul>
            <div className="py-2">
              <a onClick={handleLogout} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white cursor-pointer">Sign out</a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
